module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"journeys":"Reiser","journey":"Reise"},"en":{"journeys":"Journeys","journey":"Journey"}}')
  delete Component.options._Ctor
}
